import { EVENT_STATUS, CONTENT_TYPE } from "../../constants/event";

// Determines whether selecting an EPG item should close the EPG overlay.
// Channels always close unless already tuned in. For events, see return logic below.
export function shouldCloseEPG(event, activeLiveContent, focusKeyToReturn) {
    const hasActiveLiveContent = activeLiveContent && activeLiveContent.id;

    if (event.contentType === CONTENT_TYPE.LIVE_CHANNEL) {
        const isPlayingThisChannel = hasActiveLiveContent
            && activeLiveContent.contentType === CONTENT_TYPE.LIVE_CHANNEL
            && activeLiveContent.id === event.id;
        return !isPlayingThisChannel;
    }

    const isLiveOrComing = [EVENT_STATUS.COMING, EVENT_STATUS.LIVE].includes(event.status);
    const isPlayingThisEvent = hasActiveLiveContent
        && activeLiveContent.contentType === CONTENT_TYPE.LIVE_EVENT
        && activeLiveContent.id === event.id;
    const isScheduledAndSubscribed = event.status === EVENT_STATUS.SCHEDULED && event.isDeviceSubscribed === true;
    const isFromUpcoming = focusKeyToReturn && focusKeyToReturn.includes('upcoming');

    // Two cases that close the EPG:
    // 1. Live/Coming event → close, unless the user is already watching it (no-op in that case).
    // 2. Scheduled + subscribed event → close, unless the user navigated from the "upcoming"
    //    section — in that case keep the EPG open so they can continue browsing.
    return (isLiveOrComing && !isPlayingThisEvent) || (isScheduledAndSubscribed && !isFromUpcoming);
}
